const workApi = [
      {
          id:1,
          logo: "fas fa-download",
          title: "Download App",
          info: "First you need to install Doubtnut App from Play Store and After to create your Account with Mobile number.And choose your study what type of courses and what you want take in Doubtnut App Like-12th, JEE, NEET, CBSE, ICSE, State Board etc..",
      },
      {
        id:2,
        logo: "fas fa-chalkboard-teacher",
        title: "Take Photo Of Your Question ",
        info: "After installing Doubtnut App, you need to take photo of question in when you stucking. Take photo and after then submit to find answer. it's takes some time for giving response. It give your question multiple answer in video Format.",
    },
    {
        id:3,
        logo: "fas fa-donate",
        title: "See Solution Video Of Your Doubt",
        info: "Once comes all responses from Doubtnut side then you need to see video for solving your doubt. First you match your question and solution video if they are matches then you go for it.Sometimes it gives multiples video solution.",
    }
];
export default workApi;